import { CONTACT, tgLink, waLink } from "@/data/site";

export const Footer = () => {
  return (
    <footer data-testid="footer" className="border-t border-bp-border bg-bp-bg">
      <div className="mx-auto max-w-7xl px-6 lg:px-12 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <img src="/logo-full.png" alt="BrothersPlus TV" className="h-16 w-auto" />
            <p className="mt-4 text-sm text-[#737373] max-w-xs leading-relaxed">
              Tu servicio de IPTV premium con miles de canales, películas y series, disponible en todo el mundo.
            </p>
          </div>

          <div>
            <h4 className="text-white font-medium mb-4 text-sm">Navegación</h4>
            <ul className="space-y-2.5 text-sm text-[#737373]">
              <li><a href="#beneficios" className="hover:text-white transition-colors">Beneficios</a></li>
              <li><a href="#dispositivos" className="hover:text-white transition-colors">Dispositivos</a></li>
              <li><a href="#planes" className="hover:text-white transition-colors">Planes</a></li>
              <li><a href="#faq" className="hover:text-white transition-colors">Preguntas frecuentes</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-medium mb-4 text-sm">Contacto</h4>
            <ul className="space-y-2.5 text-sm text-[#737373]">
              <li><a href={waLink("Hola")} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">WhatsApp: {CONTACT.whatsappDisplay}</a></li>
              <li><a href={tgLink()} target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Telegram: {CONTACT.telegramDisplay}</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors">{CONTACT.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-bp-border flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#737373]">
          <span>© {new Date().getFullYear()} BrothersPlus TV. Todos los derechos reservados.</span>
          <span>Hecho con pasión por el entretenimiento.</span>
        </div>
      </div>
    </footer>
  );
};
